"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promisify = promisify;
function promisify(fn) {
    return function (options) {
        let newOptions = Object.assign({}, options);
        let res = new Promise((resolve, reject) => {
            newOptions.success = (params) => {
                var _a;
                resolve(params);
                (_a = options === null || options === void 0 ? void 0 : options.success) === null || _a === void 0 ? void 0 : _a.call(options, params);
            };
            newOptions.fail = (params) => {
                var _a;
                reject(params);
                (_a = options === null || options === void 0 ? void 0 : options.fail) === null || _a === void 0 ? void 0 : _a.call(options, params);
            };
        });
        const newRes = Object.assign(res, fn(newOptions));
        return newRes;
    };
}
//# sourceMappingURL=promisify.js.map